angular.module('picmonicng').controller('MySubscriptionsOrderHistoryController', [
  '$scope',
  'User',
  '$filter',
  'MarketOptionsConfig',
  'UserService',
  function ($scope, User, $filter, MarketOptionsConfig, UserService) {
    $scope.loading = true;
    $scope.UserService = UserService;
    $scope.now = Date.now();
    $scope.plus30days = new Date();
    $scope.plus30days.setDate($scope.plus30days.getDate() + 30);
    $scope.MarketOptionsConfig = MarketOptionsConfig;
    User.order_history({}, function (data) {
      $scope.loading = false;
      $scope.orders = data;
    });

    $scope.statuses = {
      SUCCESSFUL: 'Successful',
      Refunded: 'Refund',
      Voided: 'Refunded',
      ERROR: 'Declined',
    };

    $scope.activeOrders = function (order) {
      var orders = $filter('filter')($scope.orders, {
        package_id: order.package_id,
        order_status: 'Active',
      });
      return orders.length;
    };
    $scope.createDate = function (date) {
      return new Date(date).getTime();
    };
  },
]);
